import {
  IItem,
  IValueContainable,
  IImageDrawable,
} from "../../../../../../../domain/document/items";
import { IValueAccessible } from "../IValueAccessible";

export abstract class AbstractValueAccessor<T, TAccessor extends IValueAccessible<T> = IValueAccessible<T>> implements IValueAccessible<T> {
  constructor(source: TAccessor) {
    this._source = source;
  }

  protected readonly _source: TAccessor;

  validate(): void {
    this._source.validate();
  }

  get(): T {
    return this._source.get();
  }

  set(value: T): IItem {
    return this._source.set(value);
  }
}

export abstract class AbstractItemValueAccessor<TItem extends IItem & IValueContainable, TValue> implements IValueAccessible<TValue> {
  constructor(protected readonly _source: TItem) {}

  validate(): void {
    this._validate(this._source);
  }

  protected abstract _validate(source: TItem): void;

  get(): TValue {
    this.validate();
    return this._get(this._source);
  }

  protected abstract _get(source: TItem): TValue;

  set(value: TValue): IItem {
    this.validate();
    const cloned = this._source.clone() as TItem;
    this._set(cloned, value);
    return cloned;
  }

  protected abstract _set(source: TItem, value: TValue): void;
}

export abstract class AbstractImageDrawableAccessor<TItem extends IItem & IImageDrawable, TValue> implements IValueAccessible<TValue> {
  constructor(protected readonly _source: TItem) {}

  validate(): void {
    this._validate(this._source);
  }

  protected abstract _validate(source: TItem): void;

  get(): TValue {
    this.validate();
    return this._get(this._source);
  }

  protected abstract _get(source: TItem): TValue;

  set(value: TValue): IItem {
    this.validate();
    const cloned = this._source.clone() as TItem;
    this._set(cloned, value);
    return cloned;
  }

  protected abstract _set(source: TItem, value: TValue): void;
}
